import { render } from "./BrowseByAreaPage.vue?vue&type=template&id=3ef501a8&scoped=true"
import script from "./BrowseByAreaPage.vue?vue&type=script&lang=js"
export * from "./BrowseByAreaPage.vue?vue&type=script&lang=js"

import "./BrowseByAreaPage.vue?vue&type=style&index=0&id=3ef501a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef501a8"]])

export default __exports__